import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Goals } from 'generated/graphql';
import { goalsInitialState } from './state';

const goalsSlice = createSlice({
    name: 'goals',
    initialState: goalsInitialState,
    reducers: {
        SET_GOALS: (state, action: PayloadAction<Goals>) => {
            state.currentGoals = action.payload;
        },
    },
});

export const { reducer: goalsReducer, actions: goalsActions } = goalsSlice;
